import { useQuery } from "@tanstack/react-query"
import {
  useGetResourceObjectSuspense,
  useGetResource,
  getGetResourceObjectInsurancesQueryOptions,
  getGetResourceObjectMonetaryValuesQueryOptions,
} from "@/orval/gen"
import { ResourceObjectInsurance, ResourceObjectMonetaryValue } from "../types"

export function useResourceData(resourceObjectId: number) {
  const { data: resourceObject } = useGetResourceObjectSuspense({
    resourceObjectId,
  })

  const { data: resource } = useGetResource(
    { resourceId: resourceObject?.resourceId ?? -1 },
    { query: { enabled: !!resourceObject, initialData: undefined } }
  )

  const { data: insurances = [] } = useQuery(
    getGetResourceObjectInsurancesQueryOptions(
      { resourceObjectId },
      {
        query: { enabled: !!resourceObjectId },
      }
    )
  )

  const { data: monetaryValues = [] } = useQuery(
    getGetResourceObjectMonetaryValuesQueryOptions(
      { resourceObjectId },
      {
        query: { enabled: !!resourceObjectId },
      }
    )
  )

  return {
    resourceObject,
    resource,
    insurances,
    monetaryValues,
  }
}
